import { Bell, Heart, UserPlus, MessageSquare, Radio, Calendar, DollarSign, Sparkles, Mic, Lock, Phone } from 'lucide-react';
import { fmtCredits } from '../../lib/currency';

export const notificationIcons = { post_like: Heart, follow: UserPlus, new_message: MessageSquare, live_started: Radio,
  live_scheduled: Calendar, live_reminder: Bell, o2o_available: Phone, tip_received: DollarSign, post_unlocked: Sparkles,
  cohost_request: Mic, profile_access_request: Lock, profile_access_approved: Lock, profile_access_rejected: Lock, profile_access_revoked: Lock };

export const notificationLine = (n, t) => {
  const who = n.actor?.username ? `@${n.actor.username}` : t('notification_center.someone');
  const amount = n.data?.amount != null ? fmtCredits(n.data.amount) : '';
  if (n.kind === 'new_message') return `${who}: ${(n.data?.preview || '').slice(0, 80)}`;
  const key = notificationIcons[n.kind] ? n.kind : 'default';
  return t(`notification_center.events.${key}`, {
    who, amount, title: n.data?.title || '',
    time: n.data?.scheduled_at ? new Date(n.data.scheduled_at).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }) : '',
    hold: n.data?.amount > 0 ? t('notification_center.held', { amount }) : '',
    refund: n.data?.amount > 0 ? t('notification_center.refunded') : '',
  });
};

export const notificationLink = (n) => {
  const profile = n.actor?.username ? `/u/${encodeURIComponent(n.actor.username)}` : '/';
  switch (n.kind) {
    case 'new_message': return n.actor?.username ? `/messages?u=${encodeURIComponent(n.actor.username)}` : '/messages';
    case 'follow': case 'o2o_available': return profile;
    case 'live_started': case 'live_scheduled': case 'live_reminder': case 'cohost_request':
      return n.target_id ? `/lives/${n.target_id}` : '/lives';
    case 'tip_received': case 'post_unlocked': return '/lives?tab=movements';
    case 'post_like': return n.target_id ? `/p/${n.target_id}` : '/';
    case 'profile_access_request': return '/private-profile';
    case 'profile_access_approved': case 'profile_access_rejected': case 'profile_access_revoked': return profile;
    default: return '/';
  }
};

export const notificationTime = (iso, language) => {
  const seconds = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (!Number.isFinite(seconds)) return '';
  const [size, unit] = seconds < 60 ? [1, 'second'] : seconds < 3600 ? [60, 'minute'] : seconds < 86400 ? [3600, 'hour'] : [86400, 'day'];
  return new Intl.RelativeTimeFormat(language, { numeric: 'auto' }).format(-Math.floor(seconds / size), unit);
};